var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_19",
    "data-name": "Gruppe 19",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.769,
    height: 69.769,
    viewBox: "0 0 69.769 69.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M0,0H69.769V69.769H0Z",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 9.302,
    cy: 9.302,
    r: 9.302,
    transform: "translate(25.582 25.582)",
    fill: "#bcb243"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M22.349,2l-5.32,5.814H7.814A5.831,5.831,0,0,0,2,13.628V48.512a5.831,5.831,0,0,0,5.814,5.814H54.326a5.831,5.831,0,0,0,5.814-5.814V13.628a5.831,5.831,0,0,0-5.814-5.814H45.111L39.791,2ZM31.07,45.605A14.535,14.535,0,1,1,45.605,31.07,14.54,14.54,0,0,1,31.07,45.605Z",
    transform: "translate(3.814 3.814)",
    fill: "#bcb243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon-photo.2ae1fb574361668d4420b9516d3a3435.svg";
export { ForwardRef as ReactComponent };